<template>
  <div>
    <div
      class="access-code-section-outer d-flex justify-content-center"
      v-bind:style="{
        'background-image': `url(${bgImage})`,
      }"
      v-if="!state.showdataloader"
    >
      <div class="text-center mt-auto mb-auto" :style="{ width: '392px' }">
        <div class="panel-card-access d-flex flex-column">
          <div class="access-header px-3 pt-2 pb-1">Personal Message</div>
          <div class="access-sub-header">
            Welcome to {{ state.partyshortname }}
          </div>
          <div class="d-flex flex-column px-3">
            <div class="form-floating my-1">
              <textarea
                type="text"
                v-model="state.accessvalue"
                rows="4"
                style="max-height: 100px"
                class="form-control"
                id="accesscodeInput"
                autocomplete="off"
                placeholder="Access Code"
              />
              <label for="accesscodeInput">Enter Personal Message</label>
            </div>
            <div
              class="custom-error my-2"
              v-for="(error, index) in checkValidations.v$.accessvalue.$errors"
              :key="index"
            >
              {{ error.$message }}
            </div>
            <div
              class="custom-error my-2"
              v-if="state.accessvalue != '' && state.accesscodemsg"
            >
              {{ state.accesscodemsg }}
            </div>
            <div class="my-2">
              <VueRecaptcha
                :sitekey="siteKey"
                @verify="handleCaptcha"
                @expired="resetCaptcha"
                class="d-flex justify-content-center"
              />
              <div
                class="custom-error text-center mt-2"
                v-if="state.captchaStatus === 0 && state.captchaError"
              >
                {{ state.captchaError }}
              </div>
            </div>

            <div class="my-3">
              <button
                class="btn access-submit-btn"
                type="submit"
                @click="checkPersonalMessage()"
                :disabled="state.showloader"
              >
                <span v-if="!state.showloader">Submit</span>
                <div
                  class="spinner-border text-light custom-spinner-loader-btn"
                  role="status"
                  v-if="state.showloader"
                ></div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-modal-spinner-loader-access" v-if="state.showdataloader">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
    </div>
  </div>
</template>
<script setup>
import ApiService from "../service/ApiService";
import { required, helpers } from "@vuelidate/validators";
import { onMounted, reactive, watch , ref} from "vue";
// import commonFunction from "../composables/commonFunction";
import useValidate from "@vuelidate/core";
import { useRouter } from "vue-router";
import { VueRecaptcha } from "vue-recaptcha";
import bgImage from '@/assets/BJP_Goa_background.png'

const router = useRouter();
const apiService = new ApiService();
// const { encrypteData } = commonFunction();

const currentDomain = window.location.origin;
const siteKey = ref(
  currentDomain === "https://mera-neta.in"
    ? "6LeG4eQrAAAAAPc92h8iiaKOir8V4lEGcBf9LiGh"
    : "6LcRZVYrAAAAALvGNHsOVuIdqNi8zu166lRcmZOn"
);

const state = reactive({
  accessvalue: "",
  showloader: false,
  accesscodemsg: "",
  client_info: "",
  baseUrl: currentDomain,
  showdataloader: false,
  partyshortname: "",
  client_path: "",
  captchaStatus: 0, // To track CAPTCHA status
  captchaError: "",
  messageError: "",
});

const rules = {
  accessvalue: {
    required: helpers.withMessage("Please enter Access Code", required),
  },
};

const checkValidations = reactive({
  v$: reactive(useValidate(rules, state)),
});

onMounted(() => {
  // let masterbucketname = "meraneta_admin";
  // if (
  //   state.baseUrl == "http://localhost:8080" ||
  //   state.baseUrl == "http://localhost:8081" ||
  //   state.baseUrl == "http://localhost:8083"
  // ) {
  //   state.client_path = "meraneta-dev";
  // } else {
  //   state.client_path = masterbucketname;
  // }
  // const fields = {
  //   client_path: state.client_path,
  // };
  // getAccessCodeBannerImage(fields);
  if (localStorage.client_info) {
    router.push("/login");
  }
});

watch(
  () => [state.accessvalue],
  () => {
    checkValidations.v$.accessvalue.$validate();
  }
);

const handleCaptcha = (response) => {
  if (response) {
    state.captchaStatus = 1; // CAPTCHA verified
    state.captchaError = ""; // Clear the error
  } else {
    state.captchaStatus = 0; // CAPTCHA failed
    state.captchaError = "CAPTCHA verification failed!";
  }
};

// Reset CAPTCHA
const resetCaptcha = () => {
  state.captchaStatus = 0; // Reset status
  state.captchaError = "CAPTCHA expired. Please try again.";
};

// const checkPersonalMessage = async () => {
//   checkValidations.v$.$validate();
//   let fields = {};
//   fields["personal_message"] = state.accessvalue;
//   if (!checkValidations.v$.$error && state.captchaStatus == 1) {
//     state.showloader = true;
//     await apiService
//       .checkPersonalMessage(fields)
//       .then((items) => {
//         state.showloader = false;
//         state.accesscodemsg = items?.message;
//           let targetUrl = items?.domain;
//           state.messageError = "";
//           if (!/^https?:\/\//i.test(targetUrl)) {
//             targetUrl = "https://" + targetUrl; // You can change this to 'https://' if needed
//           }
//           window.open(targetUrl, "_blank");
//       })
//       .catch((error) => {
//         state.showloader = false;
//         state.messageError = error.message;
//       });
//   } else if (state.captchaStatus == 0) {
//     state.captchaError = "Please complete the CAPTCHA!";
//   }
// };
const checkPersonalMessage = async () => {
  try {
    checkValidations.v$.$validate();
    let fields = {};
    fields["personal_message"] = state.accessvalue;

    if (!checkValidations.v$.$error && state.captchaStatus == 1) {
      state.showloader = true;

      const items = await apiService.checkPersonalMessage(fields);

      state.showloader = false;
      state.accesscodemsg = items?.message;

      let targetUrl = items?.data.domain;
      state.messageError = "";

      if (targetUrl) {
        targetUrl = "https://" + targetUrl; // Default to https if missing protocol
      }

      window.open(targetUrl, "_blank");
    } else if (state.captchaStatus == 0) {
      state.captchaError = "Please complete the CAPTCHA!";
    }
  } catch (error) {
    state.showloader = false;
    state.messageError = error.message || "An unexpected error occurred.";
  }
};
</script>
<style scoped>
.access-code-section-outer {
  height: 100vh;
  background-repeat: no-repeat;
  width: 100%;
  background-position: center center;
  background-attachment: fixed;
  background-size: cover;
  /* background: transparent linear-gradient(43deg, #E6E9F8 0%, #E9ECF9 38%, #FFFFFF 100%) 0% 0% no-repeat padding-box; */
}

.access-code-section-outer .panel-card-access {
  border: 1.5px solid #e4e4e4;
  border-radius: 6px;
  text-align: center;
  background-color: #ffffff;
  padding: 1rem;
  box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%),
    0 1px 3px 0 rgb(0 0 0 / 12%);
}

.access-code-section-outer .access-header {
  margin-top: -3rem;
  color: #ffffff;
  border: 1.5px solid #e4e4e4;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0;
  font-size: 30px;
  line-height: 1;
  background: #f76100;
}

.access-code-section-outer .access-sub-header {
  font-size: 1.5rem;
  margin: 1.5rem 0 1rem 0;
  line-height: 1.2;
}

.access-code-section-outer .access-submit-btn {
  width: 100%;
  background: #5266e5 0% 0% no-repeat padding-box;
  border-color: #5266e5;
  border-radius: 4px;
  letter-spacing: 0.26px;
  color: #ffffff;
  text-align: center;
  font-size: 13px;
  line-height: 20px;
  padding: 9px 11px;
  margin-top: 4px;
}

.access-code-section-outer .access-submit-btn:focus,
.access-code-section-outer .access-submit-btn:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 25%);
}

.access-code-section-outer .form-floating .form-control {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #c0c3c9;
  border-radius: 4px;
  font-size: 14px;
  letter-spacing: 0.42px;
  color: #0b294b;
}

.access-code-section-outer .form-floating .form-control:focus {
  box-shadow: none !important;
  outline: 0;
  text-decoration: none;
  background-color: #fff;
  border-color: #80bdff !important;
}

.access-code-section-outer .form-floating .form-control:hover {
  border: 1px solid #bcbec1;
}

.access-code-section-outer .custom-error {
  color: #de2525;
  font-size: 13px;
  text-align: left;
  letter-spacing: 0.52px;
  line-height: 20px;
}

.custom-modal-spinner-loader-access {
  background-color: #fff;
  transition-duration: 0.2s;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  color: #9cb5d9;
}
</style>
